// extracted by mini-css-extract-plugin
export default {"BoxStepInfoContainer":"BoxInfo_BoxStepInfoContainer__8nLBN","TextoInfo":"BoxInfo_TextoInfo__WsQ0t"};